export { default } from './TextInputFetch'
